const toolbarOptions = [
    [{ "header": 1 }, { "header": 2 }],
    [{ "header": [1, 2, 3, 4, 5, 6, false] }],
    
    [ "bold", "underline", "strike" ],
    [ "code-block" ],
    [ "link" ],

    [{ "list": "ordered"}, { "list": "bullet" }],
    [ "clean" ] 
];

export default toolbarOptions;
